export default async function init() {
  const galleries = document.querySelectorAll('[data-js-module="gallery"]');

  const initGallery = async () => {
    const { default: Gallery } = await import(/* webpackChunkName: "gallery" */ './gallery');
    galleries.forEach((gallery) => new Gallery(gallery));
  };

  if (galleries.length) initGallery();
}

init();
